import { PublicClientApplication } from '@azure/msal-browser';
import { AppProvider, ColorModeProvider } from './providers';
import { OverlayContainer } from '@react-aria/overlays';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config';
import { AppRoutes } from './routes';
import * as Yup from 'yup';
import React, { useContext } from 'react';

import type { MessageParams } from 'yup/es/types';
import { LanguageSelectorProvider } from './providers/LanguageSelectorProvider';
import { Localization } from './config/localization/localization';
import { LanguageSelectorContext } from './context/LanguageSelectorContext';

const App = () => {
    const publicClientApplication = new PublicClientApplication(msalConfig);

    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    // Yup validation locale.
    Yup.setLocale({
        mixed: {
            required: (params: MessageParams) => `${params.path} ${localization.translate('validation.required')}`,
        },
    });

    return (
        <LanguageSelectorProvider>
            <ColorModeProvider>
                <MsalProvider instance={publicClientApplication}>
                    <OverlayContainer>
                        <AppProvider>
                            <AppRoutes />
                        </AppProvider>
                    </OverlayContainer>
                </MsalProvider>
            </ColorModeProvider>
        </LanguageSelectorProvider>
    );
};
export default App;